/* eslint-disable import/prefer-default-export,react/forbid-prop-types,import/no-unresolved */
import React from 'react';
import PropTypes from 'prop-types';
import { MAIN_ICON_COLORS } from 'assets/components';
import BackgroundCard from 'assets/images/us-card-bg-disabled.png';
import { cardProviders, getCardCapabilities } from '../../../../screens/Card/constants';
import { CardLogo } from '../CardLogo';
import Icon from '../../../../components/Icon';
import { ICONS } from '../../../../components/Icon/constants';
import { Typography } from '../../../../components';

export const VirtualFrozenCard = ({ cardStatus, cardProvider, label, openCardSettingModal }) => {
  if (getCardCapabilities(cardProvider).usCardArtwork) {
    const galileoIPAN = cardStatus?.card_masked_number?.match(/.{1,4}/g);
    return (
      <div>
        <div
          style={{
            height: '15rem',
          }}
          className="d-flex flex-column position-relative w-100 rounded-extra pb-0">
          <div
            className="w-100 h-100 position-absolute top-0 left-0 rounded-extra"
            style={{
              backgroundImage: `url(${BackgroundCard})`,
              backgroundSize: '100% 100%',
              backgroundRepeat: 'no-repeat',
              backgroundPosition: 'center',
            }}
          />
          <div className="d-flex flex-column px-3 pt-3 h-100" style={{ zIndex: 10 }}>
            <div className="d-flex flex-row justify-content-between pb-5">
              <div className="d-flex align-items-center gap-2">
                <div
                  className="d-flex justify-content-center align-items-center"
                  style={{ width: '0.875rem', height: '0.875rem', zIndex: 10 }}>
                  <Icon icon={ICONS.SNOW} color={MAIN_ICON_COLORS.WHITE} />
                </div>
                <Typography as="p" variant="small" className="text-white">
                  {label}
                </Typography>
              </div>
              <div className="d-flex flex-row">
                <div className="position-relative d-flex justify-content-center align-items-center rounded-extra p-2 cursor-pointer">
                  <div
                    className="position-absolute rounded-extra bg-shadow top-0 bottom-0 bg-shadow w-100 h-100"
                    style={{ backdropFilter: 'blur(4px)', opacity: '0.6' }}
                  />
                  <div
                    onClick={() => openCardSettingModal()}
                    tabIndex={-1}
                    role="presentation"
                    className="d-flex justify-content-center align-items-center"
                    style={{ width: '1.3rem', height: '1.3rem', zIndex: 10 }}>
                    <Icon icon={ICONS.SETTING} color={MAIN_ICON_COLORS.WHITE} />
                  </div>
                </div>
              </div>
            </div>
            <div className="d-flex flex-row align-items-end pb-4">
              <Typography as="p" variant="baseBold" className="text-white">
                {galileoIPAN && galileoIPAN?.length === 4
                  ? `${galileoIPAN[0]} **** **** ${galileoIPAN[3]}`
                  : '**** **** **** ****'}
              </Typography>
            </div>
            <div className="d-flex flex-row flex-fill justify-content-end align-items-center">
              <CardLogo
                cardProvider={cardProvider}
                cardNetwork={cardStatus?.network?.toUpperCase() || ''}
              />
            </div>
          </div>
        </div>
      </div>
    );
  }

  return (
    <svg
      width="100%"
      height="100%"
      viewBox="0 0 370 218"
      fill="none"
      xmlns="http://www.w3.org/2000/svg">
      <mask
        id="mask0_36113_220783"
        style={{ maskType: 'alpha' }}
        maskUnits="userSpaceOnUse"
        x="0"
        y="0"
        width="370"
        height="218">
        <rect width="370" height="218" rx="15.2692" fill="#191919" />
      </mask>
      <g mask="url(#mask0_36113_220783)">
        <rect
          x="370"
          y="219"
          width="370"
          height="220"
          transform="rotate(-180 370 219)"
          fill="#D9D9D9"
        />
        <rect
          x="-6.99951"
          y="-9"
          width="380"
          height="241"
          fill="url(#paint0_linear_36113_220783)"
          fillOpacity="0.5"
        />
        <path d="M388 -26H-21.9995V247H388V-26Z" fill="url(#paint1_linear_36113_220783)" />
        <rect
          x="-0.27832"
          y="0.101562"
          width="370.278"
          height="217.586"
          fill="url(#paint4_linear_36113_220783)"
          fillOpacity="0.3"
        />
        <rect
          x="-0.27832"
          y="0.101562"
          width="370.278"
          height="217.586"
          fill="url(#paint5_linear_36113_220783)"
        />
        <g opacity="0.6">
          <rect
            x="-0.27832"
            y="0.101562"
            width="370.278"
            height="217.586"
            fill="url(#paint6_linear_36113_220783)"
          />
          <rect
            x="-0.27832"
            y="0.101562"
            width="370.278"
            height="217.586"
            fill="url(#paint7_linear_36113_220783)"
          />
        </g>
        <g opacity="0.8">
          <rect
            x="-0.27832"
            width="370.278"
            height="217.586"
            fill="url(#paint8_linear_36113_220783)"
            fillOpacity="0.7"
          />
          <rect
            x="-0.27832"
            width="370.278"
            height="217.586"
            fill="url(#paint9_linear_36113_220783)"
          />
        </g>
        <path
          d="M322.22 26.4666C322.601 20.8425 327.131 16.4493 332.761 16.1616C334.629 16.0661 336.511 16 338.142 16C339.683 16 341.45 16.0591 343.218 16.1463C348.985 16.4307 353.568 21.0229 353.851 26.7903C353.939 28.6031 354 30.419 354 32C354 33.581 353.939 35.3969 353.851 37.2097C353.568 42.9771 348.985 47.5693 343.218 47.8537C341.45 47.9409 339.683 48 338.142 48C336.511 48 334.629 47.9339 332.761 47.8384C327.131 47.5507 322.601 43.1575 322.22 37.5334C322.091 35.6148 322 33.6763 322 32C322 30.3237 322.091 28.3852 322.22 26.4666Z"
          fill="white"
          fillOpacity="0.5"
        />
        <rect
          x="330.5"
          y="27"
          width="15"
          height="10.8333"
          rx="2"
          stroke="#191919"
          strokeWidth="1.5"
        />
        <path d="M333.833 34.5H333.841" stroke="#191919" strokeWidth="1.5" strokeLinecap="round" />
        <path d="M331.333 31.166H345.5" stroke="#191919" strokeWidth="1.5" strokeLinecap="round" />
      </g>
      <CardLogo
        cardNetwork={cardStatus?.network?.toUpperCase() || ''}
        cardProvider={cardProvider}
      />

      <text fill="black" fontWeight="bold" fontSize={16} x={15} y={122}>
        {cardProvider === cardProviders.MONAVATE
          ? cardStatus?.cardNumberObscured?.match(/.{1,4}/g).join(' ')
          : cardStatus?.cardNumberObscured?.replaceAll('-', ' ')}
      </text>

      <path
        d="M30.667 32.59V31.41h-2.885l2.055-2.055-.833-.833-2.889 2.889H24.59v-1.526l2.888-2.889-.833-.833-2.055 2.055v-2.885H23.41v2.885l-2.055-2.055-.833.833 2.888 2.889v1.526h-1.525l-2.889-2.889-.833.833 2.055 2.056h-2.885v1.178h2.885l-2.055 2.055.833.833 2.889-2.888h1.525v1.525l-2.888 2.889.833.834 2.055-2.056v2.885h1.179v-2.885l2.055 2.056.833-.834-2.888-2.889V32.59h1.525l2.889 2.888.833-.833-2.055-2.055h2.885ZM40.846 29.201c-.942 0-1.686.315-2.233.944-.543.625-.814 1.482-.814 2.572 0 1.12.261 1.988.785 2.601.527.61 1.277.914 2.25.914.598 0 1.28-.107 2.045-.322v.873c-.594.223-1.326.334-2.197.334-1.262 0-2.237-.383-2.924-1.148-.684-.766-1.026-1.854-1.026-3.264 0-.883.165-1.656.493-2.32a3.578 3.578 0 0 1 1.43-1.535c.624-.36 1.359-.54 2.202-.54.899 0 1.684.165 2.356.493l-.422.855a4.54 4.54 0 0 0-1.945-.457ZM48.91 37l-.194-.914h-.047c-.32.402-.64.676-.96.82-.317.14-.713.211-1.19.211-.637 0-1.137-.164-1.5-.492-.36-.328-.539-.795-.539-1.4 0-1.297 1.037-1.977 3.111-2.04l1.09-.035v-.398c0-.504-.11-.875-.328-1.113-.215-.242-.56-.364-1.037-.364-.535 0-1.14.165-1.816.493l-.3-.745a4.588 4.588 0 0 1 1.038-.404 4.541 4.541 0 0 1 1.137-.146c.765 0 1.332.17 1.699.51.37.34.556.884.556 1.634V37h-.72Zm-2.197-.685c.605 0 1.08-.167 1.423-.499.348-.332.522-.797.522-1.394v-.58l-.973.04c-.773.028-1.332.15-1.676.364-.34.211-.51.541-.51.99 0 .352.106.62.317.803.215.184.514.276.897.276Zm8.217-5.854c.285 0 .541.023.768.07l-.135.903a3.314 3.314 0 0 0-.703-.088c-.52 0-.965.21-1.336.633-.367.421-.551.947-.551 1.576V37H52v-6.422h.803l.111 1.19h.047c.238-.418.526-.74.861-.967.337-.227.706-.34 1.108-.34Zm6.7 5.678h-.053c-.45.652-1.121.978-2.016.978-.84 0-1.494-.287-1.962-.861-.465-.574-.698-1.39-.698-2.45 0-1.058.235-1.88.703-2.466.47-.586 1.122-.88 1.957-.88.872 0 1.54.317 2.004.95h.076l-.04-.463-.024-.45v-2.614h.973V37h-.791l-.13-.861Zm-1.946.164c.664 0 1.145-.18 1.442-.54.3-.363.451-.947.451-1.751v-.205c0-.91-.152-1.559-.457-1.946-.3-.39-.783-.586-1.447-.586-.57 0-1.008.223-1.313.668-.3.442-.45 1.067-.45 1.875 0 .82.15 1.44.45 1.858.301.418.742.627 1.325.627Zm11.666-4.969h-1.635V37h-.973v-5.666h-1.148v-.44l1.148-.351v-.357c0-1.579.69-2.368 2.069-2.368.34 0 .738.069 1.195.205l-.252.78c-.375-.121-.695-.182-.96-.182-.368 0-.64.123-.815.37-.176.241-.264.632-.264 1.171v.416h1.635v.756Zm4.461-.873c.285 0 .541.023.768.07l-.135.903a3.314 3.314 0 0 0-.703-.088c-.52 0-.965.21-1.336.633-.367.421-.55.947-.55 1.576V37h-.973v-6.422h.802l.112 1.19h.047c.238-.418.525-.74.86-.967.337-.227.706-.34 1.108-.34Zm7.872 3.322c0 1.047-.264 1.865-.791 2.455-.527.586-1.256.88-2.186.88-.574 0-1.083-.136-1.529-.405a2.668 2.668 0 0 1-1.031-1.16c-.242-.504-.363-1.094-.363-1.77 0-1.047.261-1.861.785-2.443.523-.586 1.25-.88 2.18-.88.898 0 1.61.3 2.138.897.531.598.797 1.407.797 2.426Zm-4.892 0c0 .82.163 1.445.492 1.875.328.43.81.645 1.447.645s1.12-.213 1.447-.639c.332-.43.498-1.057.498-1.88 0-.817-.166-1.436-.498-1.858-.328-.426-.814-.639-1.459-.639-.636 0-1.117.21-1.441.627-.324.418-.487 1.041-.487 1.87ZM89.862 37h-4.658v-.662l3.504-5.004h-3.287v-.756h4.353v.756l-3.457 4.91h3.545V37Zm4.58.117c-.95 0-1.7-.289-2.25-.867-.548-.578-.821-1.38-.821-2.408 0-1.035.254-1.858.762-2.467.511-.61 1.197-.914 2.056-.914.805 0 1.442.266 1.91.797.47.527.703 1.224.703 2.092v.615H92.38c.02.754.209 1.326.568 1.717.363.39.873.586 1.53.586.69 0 1.374-.145 2.05-.434v.867c-.344.149-.67.254-.978.317-.305.066-.674.1-1.108.1Zm-.264-5.842c-.516 0-.928.168-1.237.504-.305.336-.484.801-.539 1.395h3.358c0-.614-.137-1.082-.41-1.406-.274-.329-.665-.493-1.172-.493ZM103.22 37v-4.154c0-.524-.119-.914-.357-1.172-.239-.258-.612-.387-1.119-.387-.672 0-1.165.182-1.477.545-.313.363-.469.963-.469 1.799V37h-.972v-6.422h.79l.159.879h.047c.199-.316.478-.56.838-.732a2.693 2.693 0 0 1 1.201-.264c.773 0 1.355.187 1.746.562.39.372.586.967.586 1.787V37h-.973Z"
        fill="black"
      />

      <defs>
        <linearGradient
          id="paint0_linear_36113_220783"
          x1="-6.99951"
          y1="18.1716"
          x2="206.483"
          y2="641.024"
          gradientUnits="userSpaceOnUse">
          <stop stopColor="white" stopOpacity="0.64" />
          <stop offset="1" stopColor="white" stopOpacity="0.69" />
        </linearGradient>
        <linearGradient
          id="paint1_linear_36113_220783"
          x1="388.001"
          y1="110.5"
          x2="-21.9995"
          y2="110.5"
          gradientUnits="userSpaceOnUse">
          <stop stopColor="#B0B0B0" />
          <stop offset="0.5" stopColor="#DEDEDE" />
          <stop offset="1" stopColor="#B0B0B0" />
        </linearGradient>
        <linearGradient
          id="paint2_linear_36113_220783"
          x1="388.001"
          y1="110.5"
          x2="-21.9996"
          y2="110.5"
          gradientUnits="userSpaceOnUse">
          <stop stopColor="#C9C9C9" />
          <stop offset="0.5" stopColor="white" />
          <stop offset="1" stopColor="#C9C9C9" />
        </linearGradient>
        <linearGradient
          id="paint3_linear_36113_220783"
          x1="388.001"
          y1="110.5"
          x2="-21.9996"
          y2="110.5"
          gradientUnits="userSpaceOnUse">
          <stop stopColor="#B2B2B2" />
          <stop offset="0.5" stopColor="#E8E8E8" />
          <stop offset="1" stopColor="#B2B2B2" />
        </linearGradient>
        <linearGradient
          id="paint4_linear_36113_220783"
          x1="16.2633"
          y1="175.697"
          x2="195.523"
          y2="592.318"
          gradientUnits="userSpaceOnUse">
          <stop stopColor="#828282" />
          <stop offset="1" stopColor="#4F4F4F" />
        </linearGradient>
        <linearGradient
          id="paint5_linear_36113_220783"
          x1="346.93"
          y1="189.956"
          x2="80.6364"
          y2="25.3031"
          gradientUnits="userSpaceOnUse">
          <stop stopColor="white" stopOpacity="0" />
          <stop offset="0.443463" stopColor="white" stopOpacity="0.18" />
          <stop offset="1" stopColor="white" stopOpacity="0" />
        </linearGradient>
        <linearGradient
          id="paint6_linear_36113_220783"
          x1="93.1564"
          y1="72.097"
          x2="234.333"
          y2="321.974"
          gradientUnits="userSpaceOnUse">
          <stop stopColor="#D8D8D8" stopOpacity="0.54" />
          <stop offset="1" stopColor="#A2A2A2" />
        </linearGradient>
        <linearGradient
          id="paint7_linear_36113_220783"
          x1="346.93"
          y1="189.956"
          x2="14.0719"
          y2="-22.3925"
          gradientUnits="userSpaceOnUse">
          <stop stopColor="white" stopOpacity="0" />
          <stop offset="0.814799" stopColor="white" stopOpacity="0.18" />
          <stop offset="1" stopColor="white" stopOpacity="0" />
        </linearGradient>
        <linearGradient
          id="paint8_linear_36113_220783"
          x1="13.0822"
          y1="191.604"
          x2="196.019"
          y2="592.331"
          gradientUnits="userSpaceOnUse">
          <stop stopColor="#7D7B88" stopOpacity="0" />
          <stop offset="1" stopColor="#797979" stopOpacity="0.63" />
        </linearGradient>
        <linearGradient
          id="paint9_linear_36113_220783"
          x1="331.191"
          y1="197.966"
          x2="99.7447"
          y2="35.8928"
          gradientUnits="userSpaceOnUse">
          <stop stopColor="white" stopOpacity="0" />
          <stop offset="0.333708" stopColor="white" stopOpacity="0.72" />
          <stop offset="1" stopColor="white" stopOpacity="0" />
        </linearGradient>
        <clipPath id="clip0_36113_220783">
          <rect width="51.5487" height="40" fill="white" transform="translate(302.451 162)" />
        </clipPath>
        <clipPath id="clip1_36113_220783">
          <rect width="51.5487" height="40" fill="white" transform="translate(302.451 162)" />
        </clipPath>
      </defs>
    </svg>
  );
};

VirtualFrozenCard.propTypes = {
  cardStatus: PropTypes.object,
  cardProvider: PropTypes.string,
  label: PropTypes.string,
  openCardSettingModal: PropTypes.func.isRequired,
};

VirtualFrozenCard.defaultProps = {
  cardStatus: null,
  cardProvider: null,
  label: '',
};
